<template>
    <div
        v-if="( showTrigger ) || dialogVisible"
        :class="[
            'limit-notice-trigger',
            {
                'limit-notice-trigger--with-button': showTrigger
            }
        ]"
    >
        <button
            v-if="showTrigger"
            type="button"
            class="limit-notice-trigger__button"
            @click="openDialog"
        >
            {{ $t( 'cart.limitNoticeTrigger' ) }}
        </button>
        <ReoDialog
            v-if="dialogVisible"
            class="showCountry"
            :title="dialogTitle"
            :supportList="addOnSupportList"
            isButtonCentered
            isBottomWhenMobile
            @cancel="handleCancel"
        >
            <div
                v-if="!hasAddOn"
                class="limit-notice-dialog-trigger__plain"
            >
                <p
                    class="limit-notice-dialog-trigger__plain-content"
                    v-html="singleNoteContent"
                />
            </div>
        </ReoDialog>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import ReoDialog from '@/basic/Dialog.vue';
import reolinkGa from '@/common/js/gtagPageview';
import { ESeriesCategory } from '@reolink-cloud/interface';
import CheckoutItem from '../lib/checkoutItem';

export default Vue.extend({
    components: {
        ReoDialog
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        showTrigger: {
            type: Boolean,
            default: false
        },
        checkoutItems: {
            type: Array as PropType<CheckoutItem[]>,
            default: () => []
        },
        confirmMode: {
            type: String as PropType<'close' | 'emit'>,
            default: 'close'
        },
        confirmLabel: {
            type: String,
            default: ''
        }
    },
    data () {

        return {
            internalVisible: false
        };

    },
    computed: {
        firstCheckoutItem(): CheckoutItem | undefined {

            return this.checkoutItems[0];

        },
        hasAddOn(): boolean {

            return this.checkoutItems.some( item => item.plan.series?.category === ESeriesCategory.CLOUD_DATA_ADD_ON_PLAN );

        },
        currentPlanTypeSuffer(): string {

            return this.firstCheckoutItem?.planType === ESeriesCategory.CLOUD_STORAGE_PLAN ? 'Cloud Storage Service' : 'sim list';

        },
        dialogVisible(): boolean {

            return  this.value || this.internalVisible ;

        },
        addOnSupportList(): Array<{ title: string; content: string; }> | undefined {

            if ( !this.hasAddOn ) {

                return undefined;

            }
            return [
                {
                    title: this.$t( 'cart.traffic_note.note1.title' ).toString(),
                    content: this.$t( 'cart.traffic_note.note1.content' ).toString()
                },
                {
                    title: this.$t( 'cart.traffic_note.note2.title' ).toString(),
                    content: this.$t( 'cart.traffic_note.note2.content' ).toString()
                }
            ];

        },
        dialogTitle(): string {

            return this.hasAddOn
                ? this.$t( 'cart.limitTitle' ).toString()
                : this.$t( 'cart.traffic_note.note1.title' ).toString();

        },
        singleNoteContent(): string {

            return this.$t( 'cart.traffic_note.note1.content' ).toString();

        },
        resolvedConfirmLabel(): string {

            if ( this.confirmLabel ) {

                return this.confirmLabel;

            }
            if ( this.confirmMode === 'emit' ) {

                return this.$t( 'cart.countryLimitConfirm' ).toString();

            }
            return this.$t( 'cancel_plan.got_it' ).toString();

        }
    },
    methods: {
        openDialog(): void {

            this.updateVisible( true );

        },
        closeDialog(): void {

            this.updateVisible( false );

        },
        updateVisible( value: boolean ): void {

            this.internalVisible = value;
            this.$emit( 'input', value );

        },
        handleConfirm(): void {

            if ( this.confirmMode === 'emit' ) {

                this.$emit( 'confirm' );

            }
            this.closeDialog();

        },
        handleCancel(): void {

            reolinkGa.sendSimpleEvent( `${this.currentPlanTypeSuffer}-Important Notice-X` );
            this.$emit( 'cancel' );
            this.closeDialog();

        }
    }
});
</script>

<style lang="less" scoped>
.showCountry /deep/ .reo-dialog-inner {
    width: 1020px;
}

.limit-notice-trigger--with-button {
    display: inline-flex;
    align-items: center;
    margin-left: 8px;
}

.limit-notice-trigger__button {
    padding: 0;
    border: none;
    background: transparent;
    color: @brand_light;
    font: inherit;
    line-height: inherit;
    cursor: pointer;
}

.limit-notice-trigger__button:hover {
    color: @brand_light_hover;
}

.limit-notice-dialog-trigger__plain {
    text-align: left;
    line-height: normal;

}

.limit-notice-dialog-trigger__plain-content {
    white-space: pre-line;

    @media @pc {
        font-size: 14px;
        font-weight: 500;

        /deep/ p,
        /deep/ span {
            font-size: 14px;
            font-weight: 500;
        }
    }

    @media @mobile {
        font-size: 12px;
        font-weight: 500;
    }
}
</style>
